import { CheckOutlined } from "@ant-design/icons";
import * as React from "react";

import * as styles from "./CheckerButton.module.less";

type PropsCheckerButton = {
  value: boolean | null | undefined;
  onChange(newValue: boolean): void;
};

export const CheckerButton: React.FC<PropsCheckerButton> = (props) => {
  const { value, onChange } = props;
  return (
    <button
      type="button"
      className={styles.button}
      onClick={() => onChange(!value)}
    >
      {value && <CheckOutlined />}
    </button>
  );
};
